import { useState } from "react";
import { toast } from "react-toastify";
import { useLogout, useCurrentUser } from "utils/hooks";

type Props = {
  linkId: string;
};

const useDeleteAssignmentLink = () => {
  const [deleteLoading, setDeleteLoading] = useState(false);
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const deleteAssignmentLink = async ({ linkId }: Props) => {
    if (!linkId) return toast.error("Error");

    setDeleteLoading(true);

    const args = { linkId };

    try {
      return fetch(
        `${process.env.REACT_APP_REST_API_URL}/p/assignment/delete-link`,
        {
          method: "POST",
          credentials: "include",
          body: JSON.stringify({ args }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            organizationId: user?.activeOrganizationId || "NA",
            permissionKey: "delete_links",
          },
        }
      )
        .then(async (res) => {
          if (res.status !== 200) {
            const error = await res.json();
            if (
              error?.message.includes("BRKN_6001") ||
              error?.message.includes("GGST_6002") ||
              error?.message.includes("BRKN_6007")
            ) {
              toast.warn("For security purposes please log in again.");
              logOut();
            } else {
              toast.error(`${error?.message || "Hmm, something went wrong."}`);
              return false;
            }
          }
          return await res.json();
        })
        .then((resData) => {
          if (resData.linkId) {
            toast(`${resData.message}`);
            return true;
          }
        })
        .finally(() => setDeleteLoading(false));
    } catch (error) {
      console.log(error);
    }
  };

  return { deleteAssignmentLink, deleteLoading };
};

export default useDeleteAssignmentLink;
